import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowUpLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowUpLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M16 5H5V16H8V10.1213L17.5 19.6213L19.6213 17.5L10.1213 8H16V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowUpLeft;
